// extracted by mini-css-extract-plugin
export default {"dual-list-wrapper":"dual-list_dual-list-wrapper__rMo2L","dual-list-controll-wrapper":"dual-list_dual-list-controll-wrapper__zFfvE"};